const SET_CAMPAIGNS = "SET_CAMPAIGNS";
const SET_CAMPAIGN = "SET_CAMPAIGN";
const ADD_CAMPAIGN = "ADD_CAMPAIGN";
const RESET_CAMPAIGNS = "RESET_CAMPAIGN";

export { SET_CAMPAIGNS, SET_CAMPAIGN, ADD_CAMPAIGN, RESET_CAMPAIGNS };
